export default "__VITE_ASSET__c4a380c0__"